export default {
    path: "/provider",
    name: "provider",
    component: {template: `<router-view/>`},
    children: [
      {
        path: "commissions",
        name: "provider/commissions",
        component: () => import("@/components/Providers/Commissions"),
        meta:{
          can: "admin::provider:commissions"
        }
      },
      {
        path: "balances",
        name: "provider/balances",
        component: () => import("@/components/Providers/Balances"),
        meta: {
          can: "admin::provider:balances"
        }
      },
      {
        path: "list",
        name: "provider/list",
        component: () => import("@/components/Providers/List"),
        meta: {
          can: "admin::provider:list"
        }
      }
    ]
  };



// WEBPACK FOOTER //
// ./src/router/provider.js